import { FilterByEducationLevelPipe } from './filter-by-education-level.pipe';
import { FilterRelativesByParentsPipe } from './filter-relatives-by-parents.pipe';
import { FilterRoleByEntity, RemoveParentRole } from './filter-role-by-entity.pipe';
import { CustomPricingPipe } from './pricing.pipe';
import { ReversePipe } from './reverse.pipe';
import {
    FilterGarderiePipe,
    FilterMessagePipe,
    FilterPointingsByEducationLevel,
    FilterUserPipe,
    FilterWalletTransactionByDatePipe,
    FilterWalletTransactionPipe,
    FilterWalletTransactionWithFilterPipe,
    OrderPointingByDatePipe,
    SearchMessagePipe,
} from './search.pipe';
import { SortByDate, SortByDateString } from './sort-by-date.pipe';
import { SortBy } from './sort-by.pipe';

export const pipesComponents: any[] = [
    FilterUserPipe,
    FilterMessagePipe,
    SearchMessagePipe,
    CustomPricingPipe,
    FilterGarderiePipe,
    OrderPointingByDatePipe,
    FilterWalletTransactionPipe,
    FilterWalletTransactionByDatePipe,
    FilterRoleByEntity,
    RemoveParentRole,
    ReversePipe,
    FilterRelativesByParentsPipe,
    FilterPointingsByEducationLevel,
    SortByDate,
    SortBy,
    SortByDateString,
    FilterWalletTransactionWithFilterPipe,
    FilterByEducationLevelPipe,
];

export * from './filter-by-education-level.pipe';
export * from './filter-relatives-by-parents.pipe';
export * from './filter-role-by-entity.pipe';
export * from './pricing.pipe';
export * from './reverse.pipe';
export * from './search.pipe';
export * from './sort-by-date.pipe';
export * from './sort-by.pipe';
